export default __webpack_public_path__ + "static/media/CommerceTonic.2d4fa7e9a90e6e0e2225e6866e621cde.webp";